import { DragDropModule } from '@angular/cdk/drag-drop';
import { CdkScrollableModule, ScrollingModule } from '@angular/cdk/scrolling';
import { NgModule } from '@angular/core';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { SharedModule } from '../../../../../shared';
import { CampanhaPipeModule } from '../../pipes';
import { CampanhaEnviarAnaliseFormModalModule } from '../../analise/enviar-analise-form-modal';
import { AreaLabelModule } from '../../../../areas/components/label';
import { PacoteCampanhaLabelModule } from '../../../pacotes/components/label';
import { SobDemandaLabelModule } from '../../../components/sob-demanda/label';
import { ObjetivoCampanhaBadgesModule } from '../../../objetivos/badges';
import { CampanhaROIPipelineWidgetsModule } from '../../roi/components/pipeline-widgets';
import { CampanhaVisualizarModalModule } from '../../visualizar-modal';
import { CampanhaPipelineCardInfoStatusModule } from '../../components/pipeline-card-info/status';
import { CampanhaPedidoNaoLiberadoPipelineCardModule } from '../../pedidos/nao-liberado-pipeline-card';

import { CampanhaPipelineComponent } from './campanha-pipeline.component';
import { CampanhaPipelineCardComponent } from './card';

@NgModule({
    imports: [
        SharedModule,
        CampanhaPipeModule,
        DragDropModule,
        CdkScrollableModule,
        ScrollingModule,
        InfiniteScrollModule,
        CampanhaEnviarAnaliseFormModalModule,
        AreaLabelModule,
        PacoteCampanhaLabelModule,
        SobDemandaLabelModule,
        ObjetivoCampanhaBadgesModule,
        CampanhaROIPipelineWidgetsModule,
        CampanhaVisualizarModalModule,
        CampanhaPipelineCardInfoStatusModule,
        CampanhaPedidoNaoLiberadoPipelineCardModule
    ],
    declarations: [
        CampanhaPipelineCardComponent,
        CampanhaPipelineComponent
    ],
    exports: [
        CampanhaPipelineComponent
    ]
})
export class CampanhaPipelineModule { }
